import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CalculateRechargeAmountRequest, CalculateRechargeAmountResponse } from '../../interface/CustomerRecharge';
import { ApiResponse } from '../../api/api';
import customerRechargeService from '../../services/customerRechargeService';
import { CUSTOMER_RECHARGE_ACTIONS } from '../../constant/stringConstant';

export const calculateRechargeAmount = createAsyncThunk<
  ApiResponse<CalculateRechargeAmountResponse>,
  CalculateRechargeAmountRequest,
  { rejectValue: string }
>(
  CUSTOMER_RECHARGE_ACTIONS.CALCULATE_RECHARGE_AMOUNT_TOOLKIT,
  async (request, { rejectWithValue }) => {
    try {
      return await customerRechargeService.calculateRechargeAmount(request);
    } catch (error) {
      return rejectWithValue(error as any);
    }
  }
);

export interface CalculateRechargeAmountState {
  rechargeAmount: ApiResponse<CalculateRechargeAmountResponse> | null;
  loading: boolean;
  error: string | null;
}

const initialState: CalculateRechargeAmountState = {
  rechargeAmount: null,
  loading: false,
  error: null,
};

const calculateRechargeAmountSlice = createSlice({
  name: 'calculateRechargeAmount',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(calculateRechargeAmount.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.rechargeAmount = null;
      })
      .addCase(calculateRechargeAmount.fulfilled, (state, action) => {
        state.loading = false;
        state.rechargeAmount = action.payload;
      })
      .addCase(calculateRechargeAmount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || null;
      });
  },
});

export default calculateRechargeAmountSlice.reducer;
